import Vue from 'vue'
import App from './App.vue'
import "camsng-frontend-shared";
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
